import { FieldOption } from '@/forms/types/field-option';
import { FormSchema } from '@/forms/types/schema';
import { AssociateDeviceFieldValues } from './field-values';

const associateDeviceFormSchema: FormSchema<AssociateDeviceFieldValues> = {
  unitId: {
    type: 'select',
    label: 'Unit',
    value: undefined,
    validation: { required: true },
  },
};

export const buildAssociateDeviceFormSchema = ({
  currentUnitDatabaseId,
  unitOptions,
}: {
  currentUnitDatabaseId: number | undefined;
  unitOptions: FieldOption<number>[];
}): FormSchema<AssociateDeviceFieldValues> => {
  const schema = associateDeviceFormSchema;

  schema.unitId = {
    ...schema.unitId,
    value: currentUnitDatabaseId,
    options: unitOptions,
  };

  return schema;
};
